import React from 'react'
import { SvgIcon } from '@mui/material'

export const EditMessageIcon = props => (
  <SvgIcon
    viewBox="0 0 20 20"
    sx={{ width: '20px', height: '20px', color: 'primary.main' }}
    {...props}
  >
    <path d="M15.42 4.58h-3.34a.83.83 0 1 0 0 1.67h3.34a.83.83 0 0 1 .83.83v8.1l-1.3-1.2a.83.83 0 0 0-.57-.23h-7.3a.83.83 0 0 1-.83-.83v-.84a.83.83 0 0 0-1.67 0v.84a2.5 2.5 0 0 0 2.5 2.5h6.97l2.5 2.27a.83.83 0 0 0 1.4-.6v-10a2.5 2.5 0 0 0-2.53-2.5Zm-7.85 5.84h2.01a.83.83 0 0 0 .84-.84V7.57a.83.83 0 0 0-.24-.6L5.52 2.34a.83.83 0 0 0-1.17 0L2.32 4.35a.83.83 0 0 0 0 1.18l4.65 4.65a.83.83 0 0 0 .6.24ZM4.93 4.09l3.82 3.82v.83h-.83l-3.83-3.8.84-.85Z" />
  </SvgIcon>
)
